import layoutRoomsIcon from "@/assets/icons/menu/layoutRooms.svg";
// import layoutPlanProIcon from "@/assets/icons/menu/layoutPlanPro.svg";
import activationCalendarIcon from "@/assets/icons/menu/activationCalendar.svg";
import chineseCalendarIcon from "@/assets/icons/menu/chineseCalendar.svg";
import destinyMatrixIcon from "@/assets/icons/menu/destinyMatrix.svg";
// import walkForLuckIcon from "@/assets/icons/menu/walkForLuck.svg";
// import qiMenOracleIcon from "@/assets/icons/menu/qiMenOracle.svg";
// import auspiciousDatesIcon from "@/assets/icons/menu/auspiciousDates.svg";
import qiMenDunjiaIcon from "@/assets/icons/menu/qiMenDunjia.svg";
import baziIcon from "@/assets/icons/menu/bazi.svg";
import ichingIcon from "@/assets/icons/menu/iching.svg";
import azimuthIcon from "@/assets/icons/menu/azimuth.svg";
import travelDirectionIcon from "@/assets/icons/menu/travelDirection.svg";
import runesIcon from "@/assets/icons/menu/runes.svg";
import tarotIcon from "@/assets/icons/menu/tarot.svg";
import { MenuItem } from "@/types/menuItem";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { PREMIUM_CALCULATORS } from "@/types/premiumTypes";

export const menuItems: MenuItem[] = [
  // {
  //   key: "menu.layoutPlanPro",
  //   icon: layoutPlanProIcon,
  //   menuName: ROUTE_NAMES.TO_BE_IMPLEMENTED,
  // },
  {
    key: "menu.activationCalendar",
    icon: activationCalendarIcon,
    menuName: ROUTE_NAMES.ACTIVATIONS,
    matchNames: [ROUTE_NAMES.ACTIVATIONS, ROUTE_NAMES.ACTIVATION_FORM],
    premiumType: PREMIUM_CALCULATORS.activations,
  },
  {
    key: "menu.chineseCalendar",
    icon: chineseCalendarIcon,
    menuName: ROUTE_NAMES.CHINESE_CALENDAR,
    matchNames: [
      ROUTE_NAMES.CHINESE_CALENDAR,
      ROUTE_NAMES.CHINESE_CALENDAR_DAY,
    ],
  },
  {
    key: "menu.destinyMatrix",
    icon: destinyMatrixIcon,
    menuName: ROUTE_NAMES.DESTINY_MATRIX,
  },
  // {
  //   key: "menu.walkForLuck",
  //   icon: walkForLuckIcon,
  //   menuName: ROUTE_NAMES.TO_BE_IMPLEMENTED,
  // },
  // {
  //   key: "menu.qiMenOracle",
  //   icon: qiMenOracleIcon,
  //   menuName: ROUTE_NAMES.TO_BE_IMPLEMENTED,
  // },
  // {
  //   key: "menu.auspiciousDates",
  //   icon: auspiciousDatesIcon,
  //   menuName: ROUTE_NAMES.TO_BE_IMPLEMENTED,
  // },
  {
    key: "menu.qiMenDunjia",
    icon: qiMenDunjiaIcon,
    menuName: ROUTE_NAMES.QI_MEN,
  },
  {
    key: "menu.bazi",
    icon: baziIcon,
    menuName: ROUTE_NAMES.BAZI,
  },
  {
    key: "menu.iching",
    icon: ichingIcon,
    menuName: ROUTE_NAMES.I_CZIN,
  },
  {
    key: "menu.layoutRooms",
    icon: layoutRoomsIcon,
    menuName: ROUTE_NAMES.ROOM_MAPPING,
    premiumType: PREMIUM_CALCULATORS.apartmentPlan,
  },
  {
    key: "menu.azimuth",
    icon: azimuthIcon,
    menuName: ROUTE_NAMES.AZM,
  },
  // {
  //   key: "menu.travelDirection",
  //   icon: travelDirectionIcon,
  //   menuName: ROUTE_NAMES.TO_BE_IMPLEMENTED,
  // },
  {
    key: "menu.runePredictions",
    icon: runesIcon,
    menuName: ROUTE_NAMES.DAY_RUNE_PREDICTION,
  },
  {
    key: "menu.tarotPredictions",
    icon: tarotIcon,
    menuName: ROUTE_NAMES.TAROT,
    matchNames: [
      ROUTE_NAMES.TAROT,
      ROUTE_NAMES.TAROT_DAILY,
      ROUTE_NAMES.TAROT_SITUATION,
    ],
  },
  {
    key: "menu.personalDateSelection",
    icon: chineseCalendarIcon,
    menuName: ROUTE_NAMES.PERSONAL_DATE_SELECTION,
  },
];
